<script setup lang="ts">
  const showRoomImg = [
      './images/carousel/room.jpg',
      './images/carousel/room_2.jpg'
  ]
</script>

<template>
  <div class="impx-content hp3 uk-padding uk-padding-remove-horizontal bg-color-csa pattern-1">
    <div class="uk-container">
      <div class="uk-flex-center" data-uk-grid>

        <div class="uk-width-3-4@xl uk-width-3-4@l uk-width-1-1@m uk-margin-large-top impx-margin-top-small">
          <div class="impx-intro uk-text-center uk-position-relative uk-position-z-index"><!-- intro -->
            <h2 class="uk-margin-small-top uk-margin-small-bottom  uk-heading-line line-light impx-text-white"><span>Passer de beaux moments avec nos salles</span></h2>
            <p class="impx-text-large uk-margin-remove impx-text-lighter">Pour tous vos événements heureux et conférences nos salle Conférence et Événementielle bien équipés sont prêtes à vous accueillir .</p>
          </div><!-- intro end -->
        </div>

      </div>

      <!-- service items -->
      <div class="uk-flex-center" data-uk-grid>
        <div class="uk-width-2-3@xl uk-width-2-3@l uk-width-3-4@m uk-width-1-1@s">
          <ul class="uk-child-width-1-3@xl uk-child-width-1-2@l uk-child-width-1-2@m uk-child-width-1-2@s impx-features-list" data-uk-grid>
            <li><!-- service item #1 -->
              <div class="uk-position-relative">
                <img :src="showRoomImg[0]" alt="conference" class="uk-border-circle img-70 img-centered img-100">
                <div class="impx-overlay overlay-outline light img-70 img-centered img-100"></div>
                <div class="impx-feature-caption">
                  <i class="fa fa-briefcase fa-2x impx-text-white"></i>
                  <h4 class="impx-text-white impx-text-shadow">Salle de Conférence</h4>
                </div>
              </div>
            </li><!-- service item #1 end -->
            <li><!-- service item #2 -->
              <div class="uk-position-relative">
                <img :src="showRoomImg[1]" alt="event" class="uk-border-circle img-70 img-centered img-100">
                <div class="impx-overlay overlay-outline light img-70 img-centered img-100"></div>
                <div class="impx-feature-caption">
                  <i class="fa fa-bookmark fa-2x impx-text-white"></i>
                  <h4 class="impx-text-white impx-text-shadow">Salle Événementielle</h4>
                </div>
              </div>
            </li><!-- service item #2 end -->
            <li><!-- service item #3 -->
              <div class="uk-position-relative">
                <img :src="showRoomImg[1]" alt="resort" class="uk-border-circle img-70 img-centered img-100">
                <div class="impx-overlay overlay-outline light img-70 img-centered img-100"></div>
                <div class="impx-feature-caption">
                  <i class="fa fa-football-ball fa-2x impx-text-white"></i>
                  <h4 class="impx-text-white impx-text-shadow">Salle de Loisir</h4>
                </div>
              </div>
            </li><!-- service item #3 end -->

          </ul>
        </div>
      </div>
      <!-- service items end -->
    </div>
  </div>

</template>

<style scoped>

</style>